/**
 * Pause all YouTube iframes within a given container element.
 * Requires `enablejsapi=1` on the iframe src.
 */
export function pauseYoutubeIframes(container) {
  container.querySelectorAll('iframe[src*="youtube"]').forEach((iframe) => {
    iframe.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}', 'https://www.youtube.com'
    )
  })
}
